// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getServerBaseUrl, getUrlParameter } from 'utils/urlUtils';
import app from 'config/app.json';

export const HEADER_CONTENTTYPE_APPJSON = 'application/json';
export const HEADER_CONTENTTYPE_ASSOCIATION = 'text/uri-list';

const baseQuery = fetchBaseQuery({
  baseUrl: getServerBaseUrl(),
  prepareHeaders: (headers, { getState }) => {
    headers.append('content-type', HEADER_CONTENTTYPE_APPJSON);
    const { token } = getState().auth;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

const baseQueryWithApp = async (args, api, extraOptions) => {
  // AppCode Must be in uppercase
  const appCode = getUrlParameter(window.location, app.url.paramApp)?.toUpperCase();
  if (appCode) {
    let urlWithApp = typeof args === 'string' ? args : args.url;
    if (urlWithApp.indexOf('?') < 0) {
      urlWithApp += '?';
    } else {
      urlWithApp += '&';
    }
    urlWithApp += `${app.url.paramApp}=${appCode}`;
    return baseQuery(
      args === 'string' ? urlWithApp : { ...args, url: urlWithApp },
      api,
      extraOptions
    );
  }
  return baseQuery(args, api, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithApp,
  endpoints: () => ({})
});
